<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="risk"></progress-components>
      <v-form ref="form" class="mt-12">
          <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>重症化リスク要因_既往歴 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <div class="mx-3 mb-5">下記の病気のうち、現在治療中の病気はございございますか。</div>
          <v-radio-group
            v-model="hasDuringTreatment"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectExistence" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
          v-show="hasDuringTreatment==='有' || hasDuringTreatment ===''"
        >
            <div class="mx-3">※複数回答可</div>
            <div class="mx-3 mb-5">※現在対象の病気について通院または入院されている方は診察を受け付けできません。かかりつけ医の先生とご相談ください。</div>
            <v-item-group
              class="mx-2"
            >
              <v-row v-for="(item, index) in selectRisks" :key="index">
                <v-col class="py-0">
                  <v-checkbox
                    ref="riskCheckBox"
                    @change="onChangeRisk"
                    :label="item"
                    :value="item"
                    class="py-0 mt-3"
                    dense
                    color="doorMainColor"
                    :hide-details="true"
                    v-model="riskOfSerious"
                    :rules="[requiredMultipleSelectIfNeeded(hasDuringTreatment === '有')]"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
            <v-row>
              <v-col class="other-area">
                <v-checkbox
                  v-model="riskOfSerious"
                  @change="onChangeRisk"
                  value="その他"
                  :hide-details="true"
                  :rules="[requiredMultipleSelectIfNeeded(hasDuringTreatment === '有')]"
                  class="glow mr-1"
                  color="doorMainColor"
                >
                </v-checkbox>
              </v-col>
              <v-col cols="4">
                <v-responsive :min-width="xs ? '250px' : '300px'">
                  <v-text-field
                    v-model="riskOfSeriousOther"
                    label="その他"
                    variant="underlined"
                    :rules="[requiredOtherTextMultipleSelectIfNeeded(riskOfSerious, hasDuringTreatment === '有')]"
                  >
                  </v-text-field>
                </v-responsive>
              </v-col>
            </v-row>
            <v-row dense class="mx-2 my-1">
              <div v-show="hasDuringTreatment === '有'" class="v-messages text-red">
                <div class="v-messages__message">必ず一つ以上選択してください。</div>
              </div>
            </v-row>
          </v-item-group>
        </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>重症化リスク要因_肥満(BMI30以上) </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="obesityRisk"
              class="mx-2 mb-4"
              :rules="[required]"
            >
              <v-radio class="mt-2" v-for="item in selectExistence" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>重症化リスク要因_妊娠 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="pregnancyRisk"
              class="mx-2 mb-4"
              :rules="[required]"
            >
              <v-radio class="mt-2" v-for="item in selectExistence" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>重症化リスク要因_喫煙歴 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="smokingRisk"
              class="mx-2 mb-4"
              :rules="[required]"
            >
              <v-radio class="mt-2" v-for="item in selectExistence" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>重症化リスク要因_その他 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <div class="mb-5 mx-5">臓器の移植、免疫抑制剤、抗がん剤の使用、その他の理由による免疫機能の低下の有無</div>
            <v-radio-group
              v-model="otherRisk"
              class="mx-2 mb-4"
              :rules="[required]"
            >
              <v-radio class="mt-2" v-for="item in selectExistence" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
      </v-form>
    </v-container>
    <v-container>
      <v-row v-if="fromConfirm" justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="doorAccentColor"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="clickedNext"
        >確認
        </v-btn>
      </v-row>
      <v-row v-else justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedNext"
        >次へ
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { Logger } from 'aws-amplify'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'
import { useFormValidator } from '@/func/useFormValidator'
import { useScreenOperation } from '@/func/useScreenOperation'
import { useDisplay } from 'vuetify'

const logger = new Logger('AdvanceFormRiskOfSerious');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    logger.info('AdvanceFormRiskOfSerious')
    const store = useStore()
    const router = useRouter()
    const form = ref(null)
    const riskCheckBox = ref(null)

    const { scrollToErrorPosition, scrollToTop, fromConfirmScreen, toErrorIfNotExistsId } = useScreenOperation()
    const { xs } = useDisplay()


    onMounted(() => {
      scrollToTop()
      toErrorIfNotExistsId()
    })
    const fromConfirm = computed(() => fromConfirmScreen())
    const hasDuringTreatment = computed({
      get: () => store.state.advanceInterview.hasDuringTreatment,
      set: (value) => store.dispatch('advanceInterview/serHasDuringTreatment', value)
    })
    const riskOfSerious = computed({
      get: () => store.state.advanceInterview.riskOfSerious,
      set: (value) => store.dispatch('advanceInterview/setRiskOfSerious', value)
    })

    const riskOfSeriousOther = computed({
      get: () => store.state.advanceInterview.riskOfSeriousOther,
      set: (value) => store.dispatch('advanceInterview/setRiskOfSeriousOther', value)
    })
    const obesityRisk = computed({
      get: () => store.state.advanceInterview.obesityRisk,
      set: (value) => store.dispatch('advanceInterview/setObesityRisk', value)
    })
    const pregnancyRisk = computed({
      get: () => store.state.advanceInterview.pregnancyRisk,
      set: (value) => store.dispatch('advanceInterview/setPregnancyRisk', value)
    })
    const smokingRisk = computed({
      get: () => store.state.advanceInterview.smokingRisk,
      set: (value) => store.dispatch('advanceInterview/setSmokingRisk', value)
    })
    const otherRisk = computed({
      get: () => store.state.advanceInterview.otherRisk,
      set: (value) => store.dispatch('advanceInterview/setOtherRisk', value)
    })
    const isRiskValid = ref(true)
    const onChangeRisk = () => {
      isRiskValid.value = riskOfSerious.value.length > 0 && hasDuringTreatment.value == '有'
    }

    const { requiredMultipleSelect, requiredOtherTextMultipleSelect, required , requiredMultipleSelectIfNeeded, requiredOtherTextMultipleSelectIfNeeded } = useFormValidator()
    const toBack = () => router.go(-1)

    const hasRiskOfSerious = () => {
      return (
        obesityRisk.value === '有' ||
        pregnancyRisk.value === '有' ||
        hasDuringTreatment.value === '有' ||
        otherRisk.value == '有'
      )
    }

    const clickedNext = async () => {
      onChangeRisk()
      const result = await form.value.validate()
      if (!result.valid) {
        scrollToErrorPosition()
        return
      }

      if (hasRiskOfSerious()) {
        router.push({ name: 'AdvanceInterviewCancel', params: {
          code: 102,
          page: 'risk'
        }})
        return
      }
      if (fromConfirm.value) {
        router.push('/interview/confirm')
        return
      }
      router.push('/interview/medical')
    }
    const selectRisks= ref([
      '悪性腫瘍',
      '慢性閉塞性肺疾患',
      '間質肺疾患',
      '肺塞栓症',
      '肺高血圧症',
      '気管支拡張症等',
      '慢性腎臓病',
      '心血管疾患',
      '脳血管疾患',
      '高血圧',
      '糖尿病',
      '脂質異常症',
    ])
    const selectExistence = ref([
      '有',
      '無'
    ])
    return {
      selectRisks,
      selectExistence,
      riskOfSerious,
      riskOfSeriousOther,
      requiredMultipleSelect,
      requiredOtherTextMultipleSelect,
      required,
      form,
      riskCheckBox,
      clickedNext,
      toBack,
      isRiskValid,
      onChangeRisk,
      obesityRisk,
      pregnancyRisk,
      smokingRisk,
      otherRisk,
      fromConfirm,
      hasDuringTreatment,
      requiredMultipleSelectIfNeeded,
      requiredOtherTextMultipleSelectIfNeeded,
      xs
    }
  }
})
</script>

<style scoped>
.v-input :deep(.v-label) {
  color: rgba(0, 0, 0, .87) !important;
}
.v-card-title {
  white-space: inherit !important;
}

.other-area{
  max-width: 2.5rem;
}

@media screen and (max-width: 960px) {
  .btn-area button{
    min-width: 55%!important;
  }
  .other-area{
    padding-right: 1.5rem;
  }
}

</style>

